@if (!isNarrow) {
  <a id="cms-blog-header-logo-desk" [routerLink]="buttonLink">
    <img id="cms-blog-header-wide-logo" alt="Exxact" src="https://images.exxactcorp.com/img/exx/misc/X-Exxact.svg" />
  </a>
}
@else {
  <a [routerLink]="buttonLink">
    <img id="cms-blog-header-narrow-logo" alt="Exxact" src="https://images.exxactcorp.com/img/exx/misc/x-emblem.svg" />
  </a>
}